
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/real-time",
      function () {
        return require("private-next-pages/real-time/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/real-time"])
      });
    }
  